/**
 * Wrapper around EHI-Core Form Container Component
 * @type {Object}
 */
export const formContainerCore = {
  /**
   * init method to trigger running of the formContainerCore module
   * @return {void}
   */
  init() {
    // we should always try/catch due to unpredictable clientlibs
    try {
      // these are not ES Modules, they are IIFEs that are run as soon as imported
      require('../../../../dist/ehi_cheerios/ehi-clientlibs/form/container/v2/container/clientlibs/site/js/analytics.js');
      require('../../../../dist/ehi_cheerios/ehi-clientlibs/form/container/v2/container/clientlibs/site/js/gma-form-handler.js');
      require('../../../../dist/ehi_cheerios/ehi-clientlibs/form/container/v2/container/clientlibs/site/js/gmoValidation.js');
    } catch (e) {
      console.log('[ERROR] Issue loading EHI-Core Form Container Component clientlibs');
    }
  }
};
